import React, { Component } from 'react';
import WeekDay from "./week_day";
import moment from "moment";
import "./week_bus.css";

export default class WeekBus extends Component {
	constructor() {
		super();
		this.updateScroll = this.updateScroll.bind(this);
	}
	componentDidMount () {
		window["app-calendar"].addEventListener("scroll", this.updateScroll);
	}

	componentWillUnmount() {
		window["app-calendar"].removeEventListener("scroll", this.updateScroll);
	}

	updateScroll () {
		this.camion.style.left = window["app-calendar"].scrollLeft+"px";
	}

	render() {
	    function ManageDaysInUse() {
		    this.data = {};
		    this.index = "";
		    this.setIndex = (index) => {
			    this.index = index;
		    };
		    this.getDays = () => {
			    return this.data;
			    //;D
		    };
		    this.addMove = (move,unique = false) => {
			    let alreadyCreated = this.data[this.index] === Object(this.data[this.index]);

			    //object already created for a move, was a beggining or an end, this time we add one more move

			    //the day doesn't includes salida and regreso
			    // move should be in between
			    //          can be a whole day
			    //          can be a unique move
			    if (alreadyCreated) {
			    	if (unique) {
					    throw new Error("Trying to update day with moves when should be unique");
				    }
				    this.data[this.index].moves.push(move);
			    } else {
				    this.data[this.index] = {
					    moves: [move]
				    };
			    }
		    };
		    this.getByIndex = (index) => {
			    return this.data[index];
		    };
	    }
	    let daysInUse = new ManageDaysInUse();
	    for (let INDX in this.props.services) {
		    let move = this.props.services[INDX];
		    let currentDate = moment(move.salida);
		    do {
			    let index = `data:${currentDate.format("YYYY-MM-DD")}`;
			    daysInUse.setIndex(index);

			    let isSalida = currentDate.format("YYYY-MM-DD") == move.salida.split(" ")[0];
			    let isRegreso = currentDate.format("YYYY-MM-DD") == move.regreso.split(" ")[0];

			    let {destino,id,contractor_id} = move;
			    let salida = move.salida.split(" ")[1];
			    let regreso = move.regreso.split(" ")[1];
			    let theMove = {
				    salida,
				    regreso,
				    destino,
				    id,
				    contractor_id,
			    };

			    switch (true) {
				    //|oooooooooooo|
				    case (!isSalida && !isRegreso):
					    theMove.render =  -1;
					    break;
				    //|----ooo-----|
				    case (isSalida && isRegreso):
					    theMove.render =  1;
					    break;
				    //|--------oooo|
				    case (isSalida):
					    theMove.render =  2;
					    break;
				    //|ooo---------|
				    case (isRegreso):
					    theMove.render =  0;
					    break;
			    }
			    daysInUse.addMove(theMove);
			    //move is coming back and was today... next move!
			    if (move.regreso.split(" ")[0] === currentDate.format("YYYY-MM-DD")) {
				    break;
			    }
			    currentDate = currentDate.add(1, "day");
		    } while (true)
	    }
	    let days = [];
	    let {name, id} = this.props;
	    for (let i = 0; i < this.props.dates.deltaDays; i++) {
		    let date = this.props.dates.from.clone().weekday(0).add(i, "day").format("YYYY-MM-DD");
		    days.push(
			    <WeekDay date={date} modelId={this.props.modelId} busId={id} key={`${this.props.name}-${date}`}
			             external={this.props.external}
			             uid={`${this.props.name}-${date}`}
			             busDay={this.props.busDay} {...daysInUse.getByIndex(`data:${date}`)}/>
		    );
	    }
	    return (
		    <div className="camion">
			    <div className="camion-nombre" ref={(ref) => this.camion = ref}
			         onClick={(()=>this.context.setOpenId("form-edit-bus", {
				         busId: id,
				         modelId: this.props.modelId
			         }))}>{name}</div>
			    <div className="camion-semana">
				    {days}
			    </div>
		    </div>
	    )
    }
}
WeekBus.contextTypes = {
	setOpenId: React.PropTypes.func.isRequired,
	getOpenId: React.PropTypes.func.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/components/week_bus.js
 **/